import axios from 'axios';

// Configure axios to include credentials
axios.defaults.withCredentials = true;

// Use the proxy instead of the full URL
const API_URL = '/api';

/**
 * Get application settings from the API
 * @returns {Promise<Object>} - Settings object including secondaryContactHandling and secondaryContactProperty
 */
export const getSettings = async () => {
  try {
    const response = await axios.get(`${API_URL}/settings`);
    return response.data;
  } catch (error) {
    console.error('Error fetching settings:', error);
    throw error;
  }
};

/**
 * Update application settings
 * @param {Object} settings - Settings object
 * @param {string} settings.secondaryContactHandling - How to handle secondary contacts ('manual' or 'hubspot')
 * @param {string} settings.secondaryContactProperty - HubSpot property to check for secondary contacts
 * @returns {Promise<Object>} - Updated settings object
 */
export const updateSettings = async (settings) => {
  try {
    const response = await axios.post(`${API_URL}/settings`, settings);
    return response.data;
  } catch (error) {
    console.error('Error updating settings:', error);
    throw error;
  }
}; 